import type { Components } from '@mui/material/styles';

export default function MUIRadioGroup(): Components['MuiRadioGroup'] {
  return {};
}
